import React, { useState } from "react";
import UiTable from "../../../components/table/Table";
import { useNetworkOptions } from "../../../context/contractDataLoaderService";

const OrdersTable = (props) => {
  const { data: networkOptions } = useNetworkOptions();
  let headers;
  headers = [
    { label: "Date(UTC)", val: "date" },
    { label: "Security", val: "securityName" },
    { label: "Order Type", val: "orderType" },
    { label: "Quantity", val: "quantity" },
    { label: "Price", val: "price" },
    { label: "Amount", val: "currencyAmount" },
    { label: "Action", val: "modifyTrade" },
  ];

  const data = [...props.data];

  return (
    <>
      <div className="pools-table width-100">
        <UiTable
          thead={headers}
          tbodyData={data}
          hover
          provider={props.provider}
          account={props.account}
          chainId={props.chainId}
          networkOptions={networkOptions}
          bordered={false}
          web3={props.web3}
        />
      </div>
    </>
  );
};

export default OrdersTable;
